import { Button, Grid, Modal, makeStyles } from '@material-ui/core';
import { useState } from 'react';
import { connect } from 'react-redux';
import { fetchTagsByUser } from '../../../../redux/actions/flag-actions';
import { setTimeProgress } from '../../../../redux/actions/player-actions';
import { firebase } from '../../../../firebase';
import { ReactComponent as IconMyFlags } from '../../../../images/icon-my-flags-highlight.svg';
import highlightDownActiveButton from '../../../../images/icon-thumbs-down-active.png';
import highlightDownButton from '../../../../images/icon-thumbs-down.png';
import highlightUpActiveButton from '../../../../images/icon-thumbs-up-active.png';
import highlightUpButton from '../../../../images/icon-thumbs-up.png';
import '../../../player/styles/capture-flags.css';
import ProgressBar from '../../../../components/ProgressBar';
import CaptureWithComment from '../../../../components/highlight/CaptureWithComment';
import CaptureWithTag from '../../../../components/highlight/CaptureWithTag';

const useStyles = makeStyles((theme) => ({
  '@global': {
    '*::-webkit-scrollbar': {
      width: '5px'
    },
    '*::-webkit-scrollbar-track': {
      backgroundColor: 'rgba(255,255,255,0.15)'
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(255,255,255)',
      borderRadius: '8px'
    }
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#ededef'
  },
  paper: {
    width: 500,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3)
  }
}));

const HighlightModal = ({
  open,
  onClose,
  fetchTags,
  saveFlag,
  tags,
  inputTagName,
  setInputTagName,
  inputCommentName,
  setInputCommentName,
  radioButtonValue,
  setRadioButtonValue,
  setTimeProgress_disp,
  isPersonalPodcast
}) => {
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const [tagError, setTagError] = useState({
    hasError: false,
    errorMessage: ''
  });
  const [buttonTitle, setButtonTitle] = useState('Comment / Tag');
  const [up, setUp] = useState(false);
  const [down, setDown] = useState(false);

  const renderModalCloseIcon = () => {
    return (
      <Grid
        item
        xs={12}
        className="capture-flags-modal__header-btn"
        style={{ textAlign: 'right' }}
      >
        <Button onClick={handleClose}>x</Button>
      </Grid>
    );
  };

  const handleClose = () => {
    onClose();
    setActiveStep(0);
    setInputTagName('');
    setInputCommentName('');
    setRadioButtonValue('');
    setUp(false);
    setDown(false);
    setButtonTitle('Comment / Tag');
    setTimeProgress_disp(0);
    setTagError({ hasError: false, errorMessage: '' });
  };

  const handleDirectClose = () => {
    if (up) {
      saveFlag('UPTAG', undefined);
    } else if (down) {
      saveFlag('DOWNTAG', undefined);
    } else {
      saveFlag();
    }
    handleClose();
  };

  const handleButtonTagComment = async () => {
    const token = await firebase.auth.currentUser.getIdToken();
    if (token) {
      await fetchTags(token);
    }
    setActiveStep(1);
  };

  const handleTagInputChange = (event) => {
    const { value } = event.target;
    setRadioButtonValue(null);
    setInputTagName(value);
    setTagError({ hasError: false, errorMessage: '' });
  };

  const handleCommentInputChange = (event) => {
    const { value } = event.target;
    setInputCommentName(value);
  };

  const handleRadioChange = (value) => {
    setInputTagName(value);
    setRadioButtonValue(value);
    setTagError({ hasError: false, errorMessage: '' });
  };

  const handleClickUp = () => {
    setUp(!up);
    setDown(false);
    if (up && !down) {
      setButtonTitle('Comment / Tag');
    } else {
      setButtonTitle('Comment');
    }
    setTimeProgress_disp(0);
  };

  const handleClickDown = () => {
    setUp(false);
    setDown(!down);
    if (!up && down) {
      setButtonTitle('Comment / Tag');
    } else {
      setButtonTitle('Comment');
    }
    setTimeProgress_disp(0);
  };

  return (
    <Modal
      className={classes.modal}
      open={open}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      //disableEscapeKeyDown
    >
      <div className="capture-flags-modal">
        {activeStep === 0 ? (
          <>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <IconMyFlags width="40px" height="40px" />
                <div style={{ marginLeft: '15px', color: 'var(--color-ai-green)' }}>
                Creating Audio Flag
              </div>
            </div>
            <Grid
              container
              justifyContent="space-around"
              alignItems="center"
              style={{ marginTop: '20px' }}
            >
              {!isPersonalPodcast && (
                <>
                  <Grid item xs={2}>
                    <Button
                      className="highlighting-modal-btn"
                      onClick={handleClickUp}
                    >
                      <img
                        src={up ? highlightUpActiveButton : highlightUpButton}
                      />
                    </Button>
                  </Grid>
                  <Grid item xs={2}>
                    <Button
                      className="highlighting-modal-btn"
                      onClick={handleClickDown}
                    >
                      <img
                        src={
                          down ? highlightDownActiveButton : highlightDownButton
                        }
                      />
                    </Button>
                  </Grid>
                </>
              )}
              <Grid item xs={6}>
                <Button
                  className="highlighting-modal-btn"
                  onClick={handleButtonTagComment}
                  style={{ width: '100%' }}
                >
                  <div>{buttonTitle}</div>
                </Button>
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              style={{ marginTop: '10%', marginBottom: '20px' }}
            >
              <Grid item xs={8}>
                <div
                  className="button-bar"
                  onClick={handleDirectClose}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="btn__title">Close</div>
                  {up ? (
                    <ProgressBar
                      tag={'UPTAG'}
                      saveFlag={saveFlag}
                      onComplete={handleClose}
                    />
                  ) : down ? (
                    <ProgressBar
                      tag={'DOWNTAG'}
                      saveFlag={saveFlag}
                      onComplete={handleClose}
                    />
                  ) : (
                    <ProgressBar
                      takeHighlight={saveFlag}
                      onComplete={handleClose}
                    />
                  )}
                </div>
              </Grid>
            </Grid>
          </>
        ) : (
          <>
            {renderModalCloseIcon()}
            {up ? (
              <CaptureWithComment
                tag={'UPTAG'}
                inputCommentName={inputCommentName}
                handleCommentInputChange={handleCommentInputChange}
                onClose={handleClose}
                saveFlagWithComment={saveFlag}
              />
            ) : down ? (
              <CaptureWithComment
                tag={'DOWNTAG'}
                inputCommentName={inputCommentName}
                handleCommentInputChange={handleCommentInputChange}
                onClose={handleClose}
                saveFlagWithComment={saveFlag}
              />
            ) : (
              <CaptureWithTag
                edit={false}
                tags={tags}
                inputTagName={inputTagName}
                inputCommentName={inputCommentName}
                radioButtonValue={radioButtonValue}
                handleTagInputChange={handleTagInputChange}
                handleCommentInputChange={handleCommentInputChange}
                handleRadioChange={handleRadioChange}
                onClose={handleClose}
                saveFlagWithTag={saveFlag}
                tagError={tagError}
                setTagError={setTagError}
              />
            )}
          </>
        )}
      </div>
    </Modal>
  );
};

const mapStateToProps = (store) => {
  return {
    tags: store.flag.tags,
    timeProgress: store.player.timeProgress
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchTags: (token) => {
      dispatch(fetchTagsByUser(token));
    },
    setTimeProgress_disp: (value) => {
      dispatch(setTimeProgress(value));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HighlightModal);
